<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <settings
            v-bind:title="resource('TemplateColumnTextSettings_Settings_Title')"
            v-bind:region="'right'"
            class="column-content-settings text-settings"
    >
        <template v-slot:body>
            <settings-slider
                v-if="canCalculateHorizontalMargin"
                
                v-bind:label="resource('TemplateManager_Shared_HorizontalMargin_Label')"
                v-model="model.style.horizontalMargin"
                v-bind:value-suffix="'px'"
                
                v-bind:min="0"
                v-bind:max="maxHorizontalMargin"
            >
            </settings-slider>
            
            <settings-slider
                v-bind:label="resource('TemplateManager_Shared_VerticalMargin_Label')"
                v-model="model.style.verticalMargin"
                v-bind:value-suffix="'px'"
                
                v-bind:min="0"
                v-bind:max="250"
            >
            </settings-slider>
        </template>
    </settings>
</template>

<script>
    import settingsMixin from '../../Mixins/settings';
    import resourceMixin from "../../../../Util/Mixins/resources";
    
    export default {
        name: "template-column-text-settings",
        mixins: [settingsMixin, resourceMixin],
        computed: {
            maxHorizontalMargin(){
                const vm = this;
                if(vm.canCalculateHorizontalMargin){
                    return Math.round(vm.columnRect.width / 2);
                }
                
                return vm.model.horizontalMargin;
            },
            canCalculateHorizontalMargin(){
                const vm = this;
                //We'll need to wait for a proper rectangle before we can render our horizontal slider
                return vm.columnRect.width !== 0;
            }
        },
        props: {
            columnRect: {
                //IE does not like Object/DOMRect, chrome does not like ClientRect
                // type: ClientRect,
                required: true
            }
        }
    };
</script>
